import { useState } from "react";
import { PdfPreviewCard } from "./pdf-preview-card.component";
import { PdfTemplateType } from "../../../../pdf-templates/document-template.types";
import { Button } from "../../../../components/ui/button";
import { Download, Archive, Loader2 } from "lucide-react";
import { downloadPdfZip } from "../utils/create-pdf-zip";

interface GeneratedPdf {
	orgId: string;
	clientId: string;
	clientName: string;
	pdfType: PdfTemplateType;
	base64: string;
	organizationName: string;
	settingsDiff: Record<string, any>;
}

interface PdfGridViewProps {
	pdfs: GeneratedPdf[];
}

export const PdfGridView: React.FC<PdfGridViewProps> = ({ pdfs }) => {
	const [isCreatingZip, setIsCreatingZip] = useState(false);

	if (pdfs.length === 0) {
		return null;
	}

	const handleDownloadAllAsZip = async () => {
		try {
			setIsCreatingZip(true);
			await downloadPdfZip(pdfs);
		} catch (error) {
			console.error('Error downloading zip:', error);
			alert('Fehler beim Erstellen der ZIP-Datei');
		} finally {
			setIsCreatingZip(false);
		}
	};

	// Count unique organizations
	const uniqueOrgs = new Set(pdfs.map(pdf => pdf.orgId)).size;

	return (
		<div className="bg-white border border-gray-200 rounded-lg p-6">
			<div className="flex items-center justify-between mb-4">
				<div>
					<h2 className="text-lg font-semibold text-gray-900">
						Generierte PDFs ({pdfs.length})
					</h2>
					<p className="text-sm text-gray-600 mt-1">
						{uniqueOrgs} Organisation(en), {pdfs.length} PDF(s)
					</p>
				</div>
				<Button
					onClick={handleDownloadAllAsZip}
					disabled={isCreatingZip}
					size="sm"
				>
					{isCreatingZip ? (
						<>
							<Loader2 className="w-4 h-4 mr-2 animate-spin" />
							Erstelle ZIP...
						</>
					) : (
						<>
							<Archive className="w-4 h-4 mr-2" />
							Alle als ZIP herunterladen
						</>
					)}
				</Button>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
				{pdfs.map((pdf, index) => (
					<PdfPreviewCard
						key={`${pdf.orgId}-${pdf.clientId}-${pdf.pdfType}-${index}`}
						organizationName={pdf.organizationName}
						clientName={pdf.clientName}
						pdfType={pdf.pdfType}
						base64={pdf.base64}
						settingsDiff={pdf.settingsDiff}
					/>
				))}
			</div>
		</div>
	);
};
